export enum MailGroup {
  APPLICATION_ACCEPT = 'APPLICATION_ACCEPT',
  APPLICATION_REJECT = 'APPLICATION_REJECT'
}
